import { render } from "./PendingShipmentControl.vue?vue&type=template&id=0ee0cad2&scoped=true"
import script from "./PendingShipmentControl.vue?vue&type=script&lang=js"
export * from "./PendingShipmentControl.vue?vue&type=script&lang=js"

import "./PendingShipmentControl.vue?vue&type=style&index=0&id=0ee0cad2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee0cad2"]])

export default __exports__